import { useEventReporter, useOverlayContext, useStoreActions } from "../../../contexts";
import CopyAPIKeyModal from "./CopyAPIKeyModal";
import { jsx as _jsx } from "react/jsx-runtime";
const INTEGRATION_CONFIGS = {
  make: {
    slug: 'make',
    title: 'Make',
    integrationUrl: 'https://www.make.com/en/apps'
  },
  monday: {
    slug: 'monday',
    title: 'monday.com',
    integrationUrl: 'https://monday.com/'
  },
  levvy: {
    slug: 'levvy',
    title: 'Levvy',
    integrationUrl: 'https://www.levvy.com/'
  }
};
export function useCopyAPIKeyIntegration(slug) {
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const overlayContext = useOverlayContext();
  const config = INTEGRATION_CONFIGS[slug];
  const reportConnect = () => {
    logBI(12050);
    reportToAppcues('button-click', "".concat(slug, "-vendor-clicked-connect"));
    reportToGtm('button-click', "".concat(slug, "-vendor-clicked-connect"));
    reportToHeap('integrations', 'click', "".concat(slug, "-connect"));
    reportToHubspot("vendor_clicked_connect_to_".concat(slug));
  };
  const reportCopyApiKey = () => {
    logBI(12051);
    reportToAppcues('button-click', "".concat(slug, "-vendor-copied-api-key-to-clipboard"));
    reportToGtm('button-click', "".concat(slug, "-vendor-copied-api-key-to-clipboard"));
    reportToHeap('integrations', 'click', "".concat(slug, "-copy-api-key"));
    reportToHubspot('vendor_copied_api_key_to_clipboard');
  };
  const getApiKey = () => api[slug].getApiKey();
  const showCopyAPIKeyModal = () => {
    reportConnect();
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(CopyAPIKeyModal, {
          dismissModal: dismissModal,
          slug: slug,
          title: config.title,
          integrationUrl: config.integrationUrl,
          getApiKey: getApiKey,
          onCopyApiKey: reportCopyApiKey
        });
      }
    });
  };
  return {
    showCopyAPIKeyModal
  };
}